import * as classNames from 'classnames';
import * as React from 'react';

import * as Bulma from './../../bulma';
import { withHelpersModifiers } from './../../bulma';

export interface MessageHeader<T> extends Bulma.Tag, React.HTMLProps<T> { }

export function MessageHeader({ tag = 'div', ...props }: MessageHeader<HTMLElement>) {
    const className = classNames('message-header', props.className);

    return React.createElement(tag, { ...props, className });
}

const HOC = /*@__PURE__*/withHelpersModifiers(MessageHeader);
export default HOC;



// WEBPACK FOOTER //
// ./src/components/Message/MessageHeader.tsx